import { render, staticRenderFns } from "./EResultadoAnual.vue?vue&type=template&id=52805006"
import script from "./EResultadoAnual.vue?vue&type=script&lang=js"
export * from "./EResultadoAnual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports